import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { doneChangingPaymentSource } from '@app/actions/purchase_details';
import { Popover } from '@barges/react';
import { asyncLoadScript } from '../../config/utils';
import { addSource } from '../../../app/actions/payment_sources';
import { useApplePayProcessing } from './use_apple_pay_processing';
import { getCurrentLocalization } from '../../../app/config/i18n';
import classes from './classes.module.scss';

const AddApplePayOption = ({
  topPadding = 0, kind, context, analyticsEvents, onApplePayValidatedAction, loading = false
}) => {
  const [loaded, setLoaded] = useState(false);
  const {
    startApplePayValidation, applePayValidated, error, resetError
  } = useApplePayProcessing();

  const handleApplePayClick = () => {
    setTimeout(() => {
      window.store.dispatch(addSource(kind));
    }, 500);
  };

  useEffect(() => {
    if (applePayValidated) {
      if (onApplePayValidatedAction) {
        onApplePayValidatedAction();
      }
      window.store.dispatch(doneChangingPaymentSource());
    }
  }, [applePayValidated]);

  const handleAppleMerchnantClick = () => {
    startApplePayValidation(context, analyticsEvents);
  };

  useEffect(() => {
    if (loaded && !loading) {
      const applePayButton = document.querySelector('apple-pay-button');
      const action = kind === 'am' ? handleAppleMerchnantClick : handleApplePayClick;
      if (applePayButton) {
        applePayButton.addEventListener('click', action);
      }
      return () => {
        if (applePayButton) {
          applePayButton.removeEventListener('click', action);
        }
      };
    }
    return () => {};
  }, [loaded, loading]);

  useEffect(() => {
    const scriptAlreadyExists = document.querySelector('script[src="https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js"]');

    asyncLoadScript('https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js', scriptAlreadyExists, 'sha384-k62isOxi8JG4rmOzplPz4PrUZJsaPsd3qccKhrtWhcl7M7rmaAEeyTCfCA8iBI7X')
      .then(() => {
        setLoaded(true);
      });
  }, []);

  if (!loaded || loading) {
    return <div className={ classes.skeleton } />;
  }

  const buttonStyle = () => {
    const search = (queryString.parse(window.location.search) || {});
    return search?.theme === 'dark' ? 'white' : 'dark';
  };
  const getApplePayLocale = () => {
    const currentLang = getCurrentLocalization();
    const localeMap = {
      en: 'en-US',
      es: 'es-ES',
      pt: 'pt-BR'
    };
    return localeMap[currentLang] || 'en-US';
  };

  const errorPopup = () => {
    if (!error) return null;
    return (
      <Popover isOpen={ !!error } className="apple-pay-error-popup">
        <div className={ classes.errorContainer }>
          <div className={ classes.errorTitleContainer }>{error.error_name}</div>
          <div className={ classes.errorTextContainer }>{error.error}</div>
          <button type="button" onClick={ resetError } className={ classes.errorOkBtn }>OK</button>
        </div>
      </Popover>
    );
  };

  return (
    <>
      {errorPopup()}
      <style>
        {`
        apple-pay-button {
          --apple-pay-button-height: 44px;
          --apple-pay-button-border-radius: var(--app-default-btn-lg-border-radius);
          --apple-pay-button-padding: 6px 0px;
          --apple-pay-button-box-sizing: border-box;
          width: 100%;
          margin-top: ${ topPadding }px;
        }
      `}
      </style>
      <apple-pay-button
        buttonstyle={ buttonStyle() }
        type={ kind === 'am' ? 'set-up' : 'pay' }
        locale={ getApplePayLocale() }
      />
    </>
  );
};

export default AddApplePayOption;
